import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { PromotionApprovalModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[PromotionApproval] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[PromotionApproval] Load items success', props<{ data: PaginationAdapter<PromotionApprovalModel> }>());

// item
export const loadItem = createAction('[PromotionApproval] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[PromotionApproval] Load item success', props<{ item: PromotionApprovalModel }>());
